import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const InvalidTokenError = BaseErrorSchema.extend({
  errorType: z.literal('InvalidTokenError'),
  errorReason: z.string(),
});

export type InvalidTokenError = z.infer<typeof InvalidTokenError>;
